import { getChangeAnalyticsContextUrl } from '@core/api'
import { httpClient } from '@core/http-client'

import { type TAnalyticsContextIds, type TDeviceContext } from '../types/deviceContextTypes'

export type TUpdateAnalyticsContextPayload = Omit<TAnalyticsContextIds, 'user_id'>

// `user_id` is not in the body by contract — the backend takes it from the authenticated request.
export const updateAnalyticsContext = (
    data: TUpdateAnalyticsContextPayload,
): Promise<TDeviceContext> =>
    httpClient.post(getChangeAnalyticsContextUrl(), { json: data }).json<TDeviceContext>()
